<template>
    <div class="parking" v-if="data">
        <div class="parking__wrapper">
            <div class="parking__top">
                <h1 class="parking__title">
                    Паркинг
                    <span class="parking__title-label">
                        {{data.elements.length}}
                    </span>
                </h1>
                <div class="parking__description" v-if="view === 'plan'">
                    <div class="parking__info" v-html="data.description.info"></div>
                    <ul class="parking__advantages" v-if="data.description.advantages">
                        <li class="parking__advantages-item"
                            v-for="item in data.description.advantages"
                            :key="item.text">{{ item.text }}</li>
                    </ul>
                </div>
            </div>

            <div class="parking__tabs-button">
                <div class="parking__tabs-info">Выбор машиноместа</div>
                <button :class="['button', view === 'plan' ? 'button_theme_color' : ' button_theme_stroke',
                        'button_theme_content-width']"
                        @click="view='plan'">На генплане</button>

                <button :class="['button', view === 'parametric' ? 'button_theme_color' : ' button_theme_stroke',
                        'button_theme_content-width']"
                        @click="view='parametric'">По параметрам</button>
            </div>

            <div :class="['parking__tabs-fixed', {'parking__tabs-fixed_is_top':headerHide}]">
                <span class="parking__tabs-fixed-label">Машиноместа</span>
                <span :class="['parking__tabs-fixed-tab', {'is-active': view === 'plan'}]"
                      @click="view='plan'">на генплане </span>
                <span class="parking__tabs-fixed-sep">/</span>
                <span :class="['parking__tabs-fixed-tab', {'is-active': view === 'parametric'}]"
                      @click="view='parametric'"> по параметрам</span>
            </div>

            <div class="parking__content">
                <transition name="fade" mode="out-in">
                    <component :is="view" :data="data" @clickElement="clickElement"></component>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import Observer from '../../common/scripts/observer';
import Param from './components/Param/Param.vue';
import parkingParamsTemplate from '../callback/parking-params.twig';
import Plan from './components/Plan/Plan.vue';

const observer = new Observer();

export default {
    props: ['transferData'],

    components: {
        parametric: Param,
        plan      : Plan
    },

    data: () => {
        return {
            view      : 'plan',
            data      : null,
            headerHide: false
        };
    },

    methods: {
        pullData() {
            if (!this.$appOptions.json) {
                console.error(new Error('not found json attribute'));

                return;
            }

            try {
                const response = JSON.parse(decodeURIComponent(escape(window.atob(this.$appOptions.json))));

                if (response.request && !response.request.status) {
                    throw new Error('status is false');
                }

                this.data = response.data ? response.data : response;
            } catch (error) {
                console.error(error);
            }
        },

        clickElement(element) {
            observer.publish('parking:click', element);
            const parkingParamsBlock = document.querySelector('.j-parking-params');

            // Подставляет ID машиноместа в скрытое поле формы callback
            document.querySelector('.j-form-callback input[name=flatId]').value = element.id;

            if (typeof parkingParamsBlock === 'undefined') {
                return;
            }

            parkingParamsBlock.innerHTML = parkingParamsTemplate({
                descriptionTitle : element.number,
                descriptionArea  : element.area,
                descriptionSquare: element.square,
                descriptionSize  : element.size,
                descriptionFloor : element.floorName,
                descriptionPrice : element.price
            });
        }
    },

    mounted() {
        this.pullData();

        observer.subscribe('header:mobile-show', () => {
            this.headerHide = false;
        });

        observer.subscribe('header:mobile-hide', () => {
            this.headerHide = true;
        });
    }
};
</script>
